import { styled } from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import Mileage from './Mileage';
import Timelines from './Timelines';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { set } from '../../../store/slice/timelines.response';


const MaintenanceContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${props => props.theme.size.dynamic0100};
`;

export default () => {

    const timelines = useAppSelector(state => state.timelines.value);
    const dispatch = useAppDispatch();

    useEffect(() => {

        return () => {
            dispatch(set({value : null}));
        }
    }, []);

    return timelines && (
        <MaintenanceContainer>
            <Mileage timelines={timelines} />
            <Timelines />
        </MaintenanceContainer>
    );
}